'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appEntryPoint = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _ModuleManagerContainer = require('../components/module/ModuleManagerContainer');

var _ModuleManagerContainer2 = _interopRequireDefault(_ModuleManagerContainer);

var _Store = require('../services/Store');

var _Store2 = _interopRequireDefault(_Store);

var _EnterpriseEventBus = require('../services/EnterpriseEventBus');

var _EnterpriseEventBus2 = _interopRequireDefault(_EnterpriseEventBus);

var _QueryParameterService = require('../services/QueryParameterService');

var _ScreenManagerContainer = require('../components/screen/ScreenManagerContainer');

var _ScreenManagerContainer2 = _interopRequireDefault(_ScreenManagerContainer);

var _reduxOidc = require('redux-oidc');

var _OidcUserManager = require('../services/OidcUserManager');

var _OidcManagerContainer = require('../components/oidc/OidcManagerContainer');

var _OidcManagerContainer2 = _interopRequireDefault(_OidcManagerContainer);

var _CwLog = require('../services/CwLog');

var _CwLog2 = _interopRequireDefault(_CwLog);

var _SetModuleConfigAction = require('../components/module/actions/SetModuleConfigAction');

var _SetModuleConfigAction2 = _interopRequireDefault(_SetModuleConfigAction);

var _ClickTracker = require('../services/ClickTracker');

var _AppEntryLoadDataAction = require('../components/module/actions/AppEntryLoadDataAction');

var _AppEntryLoadDataAction2 = _interopRequireDefault(_AppEntryLoadDataAction);

var _MediaQueryService = require('../services/MediaQueryService');

var _SetModuleQueryParamsAction = require('../components/module/actions/SetModuleQueryParamsAction');

var _SetModuleQueryParamsAction2 = _interopRequireDefault(_SetModuleQueryParamsAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef {Object} ApplicationConfiguration
 * @property {boolean} [isEmbedded] // true if using EnterpriseEventBus and will be embedded into a host
 * @property {boolean} [includeManageAuth] // true to use ConnectWise Manage authentication manager
 * @property {function} [manageAuthSite] // replacement for default manage site screen
 * @property {boolean} [includeMobileLayout] // true to include dispatching js media query breakpoints on store
 * @property {boolean} [includeOidc] // true if including OIDC SSO auth
 * @property {JSX.Element} [oidcLoginComponent] // login page to display when oidc user is not loaded in store
 * @property {function} [oidcErrorComponent] // error page to display when oidc has failed to load the user into the store. the error message will be passed in as oidcError prop.
 * @property {function} [onBeforeAppLoad] // function to allow dynamic setup with config.json response
 * @property {JSX.Element} [loadingComponent] // loading component to display when in loading state
 * @property {JSX.Element} [screenComponent] // true to render any component directly such as react router and not routing using screen factory
 * @property {function} [getDialog] // dialog factory
 * @property {function} [getScreen] // screen factory if routing using query parameters
 * @property {string} [configJsonPath] // custom config.json path
 */

/**
 * Loads app module data and attaches application to DOM and renders
 * @param {string} moduleId 
 * @param {boolean} isStandalone
 * @param {any} moduleData
 * @param {string} elementId 
 * @param {ApplicationConfiguration} appConfig
 * @param {any} configJson
 */
var onReady = function onReady(moduleId, isStandalone, moduleData, elementId, appConfig, configJson) {
  // initialize store with module data for clicktracking 
  (0, _Store2.default)().dispatch((0, _AppEntryLoadDataAction2.default)(moduleId, elementId, isStandalone, moduleData || (0, _QueryParameterService.getQueryParameters)()));

  // log click track load of application 
  (0, _ClickTracker.addAppLoadTrack)();

  if (appConfig.includeMobileLayout) {
    (0, _MediaQueryService.loadMediaQueryService)();
  }

  // allow dynamic configuration using config.json response
  if (appConfig.onBeforeAppLoad) {
    appConfig.onBeforeAppLoad(configJson);
  }

  var module = _react2.default.createElement(
    _ModuleManagerContainer2.default,
    {
      loadingComponent: appConfig.loadingComponent,
      includeManageAuth: appConfig.includeManageAuth,
      manageAuthSite: appConfig.manageAuthSite,
      getDialog: appConfig.getDialog },
    appConfig.screenComponent ? appConfig.screenComponent : _react2.default.createElement(_ScreenManagerContainer2.default, { getScreen: appConfig.getScreen })
  );

  // render app
  _reactDom2.default.render(_react2.default.createElement(
    _reactRedux.Provider,
    { store: (0, _Store2.default)() },
    appConfig.includeOidc ? _react2.default.createElement(
      _reduxOidc.OidcProvider,
      { store: (0, _Store2.default)(), userManager: (0, _OidcUserManager.userManager)() },
      _react2.default.createElement(
        _OidcManagerContainer2.default,
        { loginComponent: appConfig.oidcLoginComponent, errorComponent: appConfig.oidcErrorComponent, loadingComponent: appConfig.loadingComponent },
        module
      )
    ) : module
  ), document.getElementById(elementId));
};

/**
 * Startup entry point for modules
 * @param {string} moduleId 
 * @param {ApplicationConfiguration} appConfig
 */
var appEntryPoint = exports.appEntryPoint = function appEntryPoint(moduleId, appConfig) {
  // load dynamic configuration data from config.json
  return fetch(appConfig.configJsonPath || '/config.json').then(function (response) {
    if (!response.ok) {
      throw response;
    }
    return response.json();
  }).then(function (json) {
    (0, _Store2.default)().dispatch((0, _SetModuleConfigAction2.default)([], json)); // load config.json onto store

    (0, _Store2.default)().dispatch((0, _SetModuleQueryParamsAction2.default)((0, _QueryParameterService.loadQueryParameters)())); // load query paramaters onto store

    if (appConfig.isEmbedded) {
      var isStandalone = (0, _QueryParameterService.getQueryParameterBoolean)('isStandalone');

      // in standalone mode, get module data from URL query parameters
      if (isStandalone) {
        onReady(moduleId, isStandalone, undefined, 'root', appConfig, json);
        return;
      }

      // initialize and subscribe to load message from host to render application
      _EnterpriseEventBus2.default.initialize(moduleId, function (event) {
        onReady(moduleId, isStandalone, event.args, event.args.elementId, appConfig, json);
      });
      // fire ready message to host
      // this lets host know that we are ready to receive initialize message
      _EnterpriseEventBus2.default.fire('moduleready');
    } else {
      onReady(moduleId, true, undefined, 'root', appConfig, json);
    }
  }).catch(function () {
    _CwLog2.default.error('Failed to load config.json');
  });
};

exports.default = appEntryPoint;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/services/AppEntryPoint.js
// module id = 807
// module chunks = 10